import { useFormik } from 'formik';
import { Flex, Stack } from "@chakra-ui/react";
import CustomInput from "../../form-components/CustomInput";
import SubmitButton from "../../custom/SubmitButton";
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import * as Yup from 'yup';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const AddTechnologyForm = ({ technology = {}, isEdit = false }) => {
    const { postApi, patchApi } = UseApi();
    const { token } = useContext(UserInfoContext);
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            technology: technology?.technology,
            stack: technology?.stack,
        },
        validationSchema: Yup.object({
            technology: Yup.string().required('技術は必修'),
            stack: Yup.string().required('技術分類は必修'),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                patchApi(
                    `${process.env.REACT_APP_API_URL}/technology/${technology?.id}`, values, { token: token },
                    (response) => {
                        // レスポンスチェック
                        if (response.isSuccess === false) {
                            // 入力内容を確認してください。
                            //alert(Message.Common.CONFIRM_INPUT);
                            return;
                        }
                        navigate('/technologies');
                    }
                );
            } else {
                postApi(
                    `${process.env.REACT_APP_API_URL}/technology`, values, { token: token },
                    (response) => {
                        // レスポンスチェック
                        if (response.isSuccess === false) {
                            // 入力内容を確認してください。
                            //alert(Message.Common.CONFIRM_INPUT);
                            return;
                        }
                        navigate('/technologies');
                    }
                );
            }
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Stack spacing={4} key={'addTechnology'}>
                <CustomInput
                    formik={formik}
                    label={'技術分類'}
                    type={'text'}
                    name={'stack'}
                    id={'stack'}
                    placeholder={'技術分類を入力(i.e. フレームワーク)'}
                    required={true}
                />
                <CustomInput
                    formik={formik}
                    label={'技術'}
                    type={'text'}
                    name={'technology'}
                    id={'technology'}
                    placeholder={'技術を入力(i.e. Laravel)'}
                    required={true}
                />
                <Stack spacing={10}>
                    <Flex gap={2}>
                        <SubmitButton buttonText={isEdit ? '編集' : '登録'} />
                    </Flex>
                </Stack>
            </Stack>
        </form>
    );
}

export default AddTechnologyForm;